import apiClient from "./apiClient";
import { FullRasReportResponse } from "../types/rasTypes";
export const getProductionControl = async (idProject: number, tower?: String) => {
    try{
        const response = await apiClient.get(`/ProductionControl/${idProject}`,{
            params: {
                tower: tower || '',
            },
        });
        return response.data;
    }catch (error){
        console.error('Error al obtener el control de producción: ', error);
        throw error;
    }
};

export const getSummaryTowers = async (idProject: number, startDate?: string, finishDate?: string) => {
  try{
      const response = await apiClient.get(`/ProductionControl/${idProject}/summary`,{
          params: {
              startDate: startDate,
              finishDate: finishDate
          },
      });
      return response.data;
  }catch (error){
      console.error('Error al obtener el total de torres por actividad: ', error);
      throw error;
  }
};

export const getFilteredProductionControl = async (idProject: number, startDate: string, finishDate: string) => {
  const response = await apiClient.get(`/ProductionControl/${idProject}`, {
      params: {
          tower: '',
          startDate: startDate,
          finishDate: finishDate,
      },
  });
  return response.data;
};

// Esta función es la antigua del RAS. La mantenemos por si acaso,
// pero ten en cuenta que el backend ahora devuelve una estructura diferente en este endpoint.
export const getInfoRasReport = async (idProject: number, startDate: string, finishDate: string) => {
  const response = await apiClient.get(`/ras/${idProject}`, { params: { startDate, finishDate }})
  return response.data;
}

export const getFullRasReport = async (projectId: number, startDate: string, endDate: string) => {
    // Usamos apiClient en lugar de axios directo para aprovechar tu configuración base
    const response = await apiClient.get<FullRasReportResponse>(`/ras/${projectId}`, {
        params: { startDate, finishDate: endDate }
    });
    return response.data;
};